import {
	checkSelectValidity,
	checkValidity,
	toggleOptions,
} from './inputFields';

const heroContainer = document.querySelector('.hero-container');
const heroLabel = document.querySelectorAll('.hero-form-radio-label');
const calculateLink = document.querySelector('#calculateLink');

const heroForm = document.querySelector('.hero-form');
const catOptions = heroForm?.getAttribute('data-katze-options').split(' | ');
const dogOptions = heroForm?.getAttribute('data-hund-options').split(' | ');
const exoticOptions = heroForm
	?.getAttribute('data-exoten-options')
	.split(' | ');
const smallOptions = heroForm
	?.getAttribute('data-kleintier-options')
	.split(' | ');
let hasDesktopVideo = heroContainer?.getAttribute('data-has-desktop-video');
let hasMobileVideo = heroContainer?.getAttribute('data-has-mobile-video');
// hero backgroudnd
let mediaQuery = window.matchMedia('(max-width: 768px)');
let desktopCatUrl = heroContainer?.getAttribute('data-desktop-cat-background');
let desktopDogUrl = heroContainer?.getAttribute('data-desktop-dog-background');
let mobileCatUrl = heroContainer?.getAttribute('data-mobile-cat-background');
let mobileDogUrl = heroContainer?.getAttribute('data-mobile-dog-background');

const toggleButtonDesktop = document.getElementById(
	'toggle-play-pause-desktop',
);
const toggleButtonMobile = document.getElementById('toggle-play-pause-mobile');
const desktopVideo = document.getElementById('video-desktop');
const mobileVideo = document.getElementById('video-mobile');
const playIcons = document.querySelectorAll('.play-icon');
const pauseIcons = document.querySelectorAll('.pause-icon');
const animalButtons = document.querySelectorAll('.hero-animal-button');
const select = heroForm?.querySelector('select');
const selectDisplay = heroForm?.querySelector('.select-input-options');

animalButtons.forEach((it) => {
	it.addEventListener('keydown', (e) => {
		const field = it.querySelector('input');
		field.checked = true;
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			selectAnimal(field.value);
		}
	});
});

function togglePlayVideo(button, video) {
	if (button && video) {
		button.addEventListener('click', () => {
			if (video.paused) {
				video.play();
				playIcons.forEach((it) => it.classList.add('hidden'));
				pauseIcons.forEach((it) => it.classList.remove('hidden'));
			} else {
				video.pause();
				playIcons.forEach((it) => it.classList.remove('hidden'));
				pauseIcons.forEach((it) => it.classList.add('hidden'));
			}
		});
	}
}

togglePlayVideo(toggleButtonDesktop, desktopVideo);
togglePlayVideo(toggleButtonMobile, mobileVideo);

function selectAnimal(value) {
	heroLabel.forEach((label) => checkRadioCheckState(label));
	setHeroBackgroundImage(
		mediaQuery,
		'katze' ? desktopCatUrl : desktopDogUrl,
		'katze' ? mobileCatUrl : mobileDogUrl,
	);

	switch (value) {
		case 'katze':
			setOptions(select, selectDisplay, catOptions);
			break;
		case 'hund':
			setOptions(select, selectDisplay, dogOptions);
			break;
		case 'exoten':
			setOptions(select, selectDisplay, exoticOptions);
			break;
		case 'kleintier':
			setOptions(select, selectDisplay, smallOptions);
			break;
	}
}

heroLabel.forEach((label) => {
	const field = label.querySelector('input');

	setOptions(select, selectDisplay, dogOptions);

	if (field.value === 'katze' && field.checked) {
		setHeroBackgroundImage(mediaQuery, desktopCatUrl, mobileCatUrl);
	} else {
		setHeroBackgroundImage(mediaQuery, desktopDogUrl, mobileDogUrl);
	}

	checkRadioCheckState(label);
	field.addEventListener('click', () => selectAnimal(field.value));
});

function selectItem(
	option,
	displayItem,
	selectDisplay,
	href,
	shouldToggle = true,
) {
	const nativeSelect = option.parentElement;
	nativeSelect.value = displayItem.getAttribute('data-value');
	if (shouldToggle) {
		toggleOptions(selectDisplay);
	}

	const selectedDisplay = option.parentElement.parentElement.querySelector(
		'.select-curr-selected',
	);
	selectedDisplay.innerText = displayItem.innerText;

	calculateLink.href = href;
	selectedDisplay.setAttribute('data-value', option.value);
	checkValidity(option.parentElement);
	checkSelectValidity(option.parentElement);
}

function setOptions(selectEl, selectDisplay, options) {
	selectEl.innerHTML = '';
	selectDisplay.innerHTML = '';
	options.forEach((currOption) => {
		const [data, href] = currOption.split('&&**');
		const [optionText] = data.split('&*');
		const option = document.createElement('option');
		option.value = optionText;
		option.text = optionText;
		selectEl.appendChild(option);

		const displayItem = document.createElement('li');
		displayItem.classList.add('select-input-option');
		displayItem.setAttribute('data-value', optionText);
		displayItem.innerText = optionText;
		selectDisplay.appendChild(displayItem);
		displayItem.addEventListener('optionSelected', () => {
			selectItem(option, displayItem, selectDisplay, href, false);
		});
		displayItem.addEventListener('click', () =>
			selectItem(option, displayItem, selectDisplay, href),
		);
	});
	if (options.length === 1) {
		const [_, href] = options[0].split('&&**');
		window.location.href = href;
	} else {
		const option = document.createElement('option');
		option.value = '';
		option.text = `Bitte wählen${selectEl.required ? '*' : ''}`;
		selectEl.appendChild(option);
		selectEl.value = '';
		calculateLink.href = '';

		const selectedDisplay = selectEl.parentElement.querySelector(
			'.select-curr-selected',
		);
		selectedDisplay.innerText = `Bitte wählen${selectEl.required ? '*' : ''}`;
		selectedDisplay.setAttribute('data-value', '');
	}
}

function setHeroBackgroundImage(mediaQuery, desktopUrl, mobileUrl) {
	if (
		(window.innerWidth > 768 && !hasDesktopVideo) ||
		(window.innerWidth <= 768 && !hasMobileVideo)
	) {
		if (mediaQuery.matches && mobileUrl && !hasMobileVideo)
			heroContainer.style.backgroundImage = `url(${mobileUrl})`;
		else if (!mediaQuery.matches && desktopUrl && !hasDesktopVideo)
			heroContainer.style.backgroundImage = `url(${desktopUrl})`;
	}
}

// setHeroBackgroundImage(mediaQuery, desktopDogUrl, mobileDogUrl)

mediaQuery.addEventListener('change', function () {
	const currSelected = heroForm
		?.querySelector('.select-curr-selected')
		.getAttribute('data-value');
	let mobileImage = '';
	let desktopImage = '';
	heroLabel.forEach((label) => {
		const field = label.querySelector('input');
		if (field.value === 'katze' && field.checked) {
			for (let option of catOptions) {
				if (option.includes(currSelected)) {
					[desktopImage, mobileImage] = option.split('&*')[1].split('%%');
					break;
				}
			}
			mobileImage =
				mobileImage.trim().length === 0 ? mobileCatUrl : mobileImage;
			desktopImage =
				desktopImage.trim().length === 0 ? desktopCatUrl : desktopImage;
		} else {
			for (let option of dogOptions) {
				if (option.includes(currSelected)) {
					[desktopImage, mobileImage] = option.split('&*')[1].split('%%');
					break;
				}
			}

			mobileImage =
				mobileImage.trim().length === 0 ? mobileDogUrl : mobileImage;
			desktopImage =
				desktopImage.trim().length === 0 ? desktopDogUrl : desktopImage;
		}
		setHeroBackgroundImage(mediaQuery, desktopImage, mobileImage);
	});
});

function checkRadioCheckState(label, isCheckedWhite = true) {
	const field = label.querySelector('input');
	const labelText = label.querySelector('p');
	const path = label.querySelector('path');
	if (label && field) {
		label.classList.toggle('bg-white', (field.checked ^ !isCheckedWhite) === 1);
		labelText.classList.toggle(
			'text-secondary-200',
			(field.checked ^ !isCheckedWhite) === 1,
		);
		label.classList.toggle(
			'bg-secondary-200',
			(!field.checked ^ !isCheckedWhite) === 1,
		);
		labelText.classList.toggle('text-white', (!field.checked ^ !isCheckedWhite) === 1);
		path.classList.toggle(
			'fill-secondary-200',
			(field.checked ^ !isCheckedWhite) === 1,
		);
		path.classList.toggle('fill-white', (!field.checked ^ !isCheckedWhite) === 1);
	}
}

export default {
	heroContainer: heroContainer,
	heroLabel: heroLabel,
	setHeroBackgroundImage: setHeroBackgroundImage,
	checkRadioCheckState: checkRadioCheckState,
	mediaQuery: mediaQuery,
};
